import * as icons from '@next-nx/shared-ui/icons'

export const getIcon = (key: string | null | undefined, idVariant?: string | null | undefined) => {
  if (!key) return null

  const keyToComponentName = key
    .split('_')
    .map((v) => v.charAt(0).toUpperCase() + v.slice(1))
    .join('')
  //@ts-ignore
  const Icon = icons[`${keyToComponentName}`]

  if (Icon && idVariant) return <Icon idVariant={idVariant} />
  else if (Icon) return <Icon />

  return null
}
